const readMoreTarget = '.wm-job__readMoreToggle';
const readMoreFaqTarget = '.wm-faq__inner';
jQuery(document).on('ready', function () {
    jQuery(readMoreTarget).on('click', function () {
        jQuery(this).toggleClass('-active');
        jQuery(this).siblings('.wm-job__readMore').slideToggle().toggleClass('-active');
        jQuery(this).children('.wm-job__readMoreText').toggle();
        jQuery(this).children('.wm-job__readLessText').toggle();
    });
    jQuery(readMoreFaqTarget).on('click', function () {
        jQuery(this).toggleClass('-active');
        jQuery(this).children('.wm-faq__readMore').slideToggle().toggleClass('-active');
        jQuery(this).children('.wm-faq__heading').children('.wm-faq__headingText').children('.wm-faq__excerpt').slideToggle();
    });
});
